import { render, staticRenderFns } from "./NeoparentMilestones.vue?vue&type=template&id=1320b395&scoped=true"
import script from "./NeoparentMilestones.vue?vue&type=script&lang=js"
export * from "./NeoparentMilestones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320b395",
  null
  
)

export default component.exports